module.exports = __webpack_public_path__ + "media/images/pc/specials/common/event/event_costume-7a61cb7f09499f9a48ed5932b24cc6db.jpg";